import { Box, Card, CardBody, Flex, Icon, Progress, Table, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";
import { Shimmer } from "@am-tax/fe-core";
import { useParams, Link } from "react-router-dom";
import agGridDateFormatter from "../../grid/formatters/agGridDateFormatter";
import { DashboardResponse } from "../../api/models/DashboardResponse";
import { WidgetHeading } from "./WidgetHeading";
import { IconBuilding } from "@tabler/icons-react";

export const EntitiesWidget = ({ isLoading, entities }: { isLoading: boolean; entities: DashboardResponse["entityDetails"] }) => {
    const { cId } = useParams();

    return (
        <Shimmer isLoading={isLoading} width="100%" height="100%">
            <Card variant={"withShadow"} width={"100%"}>
                <CardBody px={"1.25rem"} pt={"1rem"} pb={"1.25rem"}>
                    <WidgetHeading title="Entities" url={`/clients/${cId}/entities`} linkText="Go to Entities" />
                    {entities && entities.length ? (
                        <Box overflowX="auto">
                            <Table size="sm" variant="simple">
                                <Thead>
                                    <Tr>
                                        <Th>Entity</Th>
                                        <Th isNumeric>Candidates</Th>
                                        <Th isNumeric>New This Month</Th>
                                        <Th>Hired</Th>
                                        <Th isNumeric>Questionnaires</Th>
                                        <Th>Created</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {entities.map((entity, index) => {
                                        const hiredPct = entity.totalCandidates > 0 ? (entity.totalHired / entity.totalCandidates) * 100 : 0;
                                        const questPct = entity.totalCandidates > 0 ? (entity.questionnairesCompleted / entity.totalCandidates) * 100 : 0;
                                        return (
                                            <Tr key={index} _hover={{ bg: "gray.50" }}>
                                                <Td fontWeight="medium">
                                                    <Link
                                                        to={`/clients/${cId}/entities/${entity.id}`}
                                                        style={{ color: "var(--chakra-colors-blue-600)", textDecoration: "none" }}
                                                    >
                                                        {entity.name}
                                                    </Link>
                                                </Td>
                                                <Td isNumeric>
                                                    <Link
                                                        to={`/clients/${cId}/candidates?eId=${entity.id}`}
                                                        style={{ color: "var(--chakra-colors-blue-600)", textDecoration: "none" }}
                                                    >
                                                        {entity.totalCandidates}
                                                    </Link>
                                                </Td>
                                                <Td isNumeric>
                                                    {entity.newCandidates > 0 ? (
                                                        <Text as="span" color="green.600" fontWeight="semibold">
                                                            +{entity.newCandidates}
                                                        </Text>
                                                    ) : (
                                                        <Text as="span" color="gray.400">
                                                            —
                                                        </Text>
                                                    )}
                                                </Td>
                                                <Td minW="180px">
                                                    <Flex alignItems="center" gap={2}>
                                                        <Text fontSize="xs" width="100px" flexShrink={0}>
                                                            {entity.totalHired} / {entity.totalCandidates}
                                                        </Text>
                                                        <Progress value={hiredPct} size="xs" colorScheme="green" flex={1} borderRadius="full" />
                                                    </Flex>
                                                </Td>
                                                <Td isNumeric>
                                                    <Flex alignItems="center" justifyContent="flex-end" gap={2}>
                                                        <Progress value={questPct} size="xs" colorScheme="purple" width="60px" borderRadius="full" />
                                                        <Text fontSize="xs" width="100px" flexShrink={0} textAlign="right">
                                                            {entity.questionnairesCompleted} / {entity.totalCandidates}
                                                        </Text>
                                                    </Flex>
                                                </Td>
                                                <Td>
                                                    <Text fontSize="xs" color="gray.500">
                                                        {agGridDateFormatter(entity.createdOn)}
                                                    </Text>
                                                </Td>
                                            </Tr>
                                        );
                                    })}
                                </Tbody>
                            </Table>
                        </Box>
                    ) : (
                        <Flex direction="column" align="center" justify="center" py={8} gap={2} color="gray.400">
                            <Icon as={IconBuilding} boxSize={8} />
                            <Text fontSize="sm">No entities for this client.</Text>
                        </Flex>
                    )}
                </CardBody>
            </Card>
        </Shimmer>
    );
};
